module.exports = __webpack_public_path__ + "img/shopcart_white.617e51bc.svg";